module.exports = __webpack_public_path__ + "static/img/LxxljkscV1.097b1983.png";